import request from '@/utils/request';

import type { FetchUpgradeRequestResp } from './upgradeRequest.data';

const API = 'upgrade-request';

export async function fetchUpgradeRequests(params?: any): Promise<FetchUpgradeRequestResp> {
  return request.get(`/${API}`, {
    params,
  });
}

export async function updateUpgradeRequest(id: string, params: any) {
  return request.patch(`/upgrade-request/${id}`, {
    data: params,
  });
}
